// src/lib/getRetainedValuations.js
// Pour les rapports (ARTDAI §P4) : renvoie, par œuvre, la « valeur retenue » à citer +
// sa source, depuis la traçabilité artwork_valuation_history. Priorité : la valeur validée
// (retained), sinon expertise, sinon algorithmique, sinon marché, sinon acquisition/assurance.
import { supabase } from "./supabaseClient";

const PRIORITY = ["retained", "expert", "algorithmic", "market_estimate", "acquisition", "insurance"];

export async function getRetainedValuations(artworkIds = []) {
  const map = {};
  const ids = [...new Set((artworkIds || []).filter(Boolean))];
  if (ids.length === 0) return map;
  try {
    const { data } = await supabase
      .from("artwork_valuation_history")
      .select("artwork_id,value_type,amount_retained,amount_min,amount_max,currency,valuation_date,source_name")
      .in("artwork_id", ids)
      .order("valuation_date", { ascending: false })
      .order("created_at", { ascending: false });
    const byArt = {};
    (data || []).forEach((r) => { (byArt[r.artwork_id] = byArt[r.artwork_id] || []).push(r); });
    for (const id of ids) {
      const rows = byArt[id] || [];
      let chosen = null;
      for (const type of PRIORITY) {
        chosen = rows.find((r) => r.value_type === type);
        if (chosen) break;
      }
      if (chosen) {
        map[id] = {
          amount: chosen.amount_retained ?? chosen.amount_min ?? chosen.amount_max ?? null,
          currency: chosen.currency || "EUR",
          source_name: chosen.source_name || null,
          valuation_date: chosen.valuation_date || null,
          value_type: chosen.value_type,
        };
      }
    }
  } catch {
    /* silencieux : le rapport reste généré sans provenance si la lecture échoue */
  }
  return map;
}
